const Save = () => {
    return null;
};

export default Save;
